import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PETITION_PROMOTE_PAGE_FOR_COUNTRY = createFcmDetails('petition_promote_page_for_country', {
	owner: 'United PD, site platform',
	context: 'Promote page',
	description: 'JSON containing various config data for the promotion product',
	import: false,
	template: {
		traffic_percentage: 100,
		promote_page_route: '/p/:slug/promote-async',
		safe_listed_user_identifiers: [],
		block_listed_user_identifiers: [],
		national_id_required: true,
		payment_methods: [
			{
				id: 'CARD',
				label: 'credit_card',
				icon: 'https://static.change.org/payment-options/btn/cc-active-dark.svg',
				flow: 'direct',
				show_save_payment_method_checkbox: true,
				supports_recurring: true,
			},
			{
				id: 'PC',
				label: 'PSE',
				icon: 'http://changedotorgcontent.com/wp-content/uploads/2022/02/co-pse.png',
			},
		],
	},
});
